module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('el-menu', {
    attrs: {
      "theme": "dark",
      "mode": "horizontal",
      "default-active": _vm.language,
      "router": true
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/we-plugin",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("we-plugin issue")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-633aceed"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 177
// module chunks = 1